var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "box" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "configuration-reference" }, [
        _c("div", { staticClass: "card-row row" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "md-field",
                { staticClass: "create-community" },
                [
                  _c("label", { staticClass: "card-header" }, [
                    _vm._v("Add Filter Word")
                  ]),
                  _vm._v(" "),
                  _c("md-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|max:25",
                        expression: "'required|max:25'"
                      }
                    ],
                    attrs: { name: "word", placeholder: "Add Filter Word" },
                    on: {
                      input: function($event) {
                        _vm.filterWord = _vm.sanitizeInput($event)
                      }
                    },
                    model: {
                      value: _vm.filterWord,
                      callback: function($$v) {
                        _vm.filterWord =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "filterWord"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("word"),
                      expression: "errors.has('word')"
                    }
                  ],
                  staticClass: "error"
                },
                [_vm._v(_vm._s(_vm.errors.first("word")))]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "submitBtn" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-raised md-round md-accent",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.saveFilterWord()
                    }
                  }
                },
                [_vm._v("Save")]
              ),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  staticClass: "md-raised md-round md-accent",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.cancel()
                    }
                  }
                },
                [_vm._v("Cancel")]
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("h2", { staticClass: "match-header" }, [_vm._v("Add Filter Word")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cc9eb0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cc9eb0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfigurationAdd.vue
// module id = null
// module chunks = 